export default __webpack_public_path__ + "static/media/6.94659f65.png";